export const hexToRgb = (hex) => {
    const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return rgb ? `rgb(${rgb.slice(1).map(x => parseInt(x, 16)).join(', ')})` : 'unset';
}

export const hexToRgbObject = (color) => {
	if (color.length < 6) {
		color = color.replace('#', '').split('').map((a) => a + a).join('')
	}

	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
	return result ? {
		r: parseInt(result[1], 16),
		g: parseInt(result[2], 16),
		b: parseInt(result[3], 16)
	} : null;
}

const clamp = (value, min, max) => Math.min(max, Math.max(value, min))

export const rgbToHex = (r, g, b) => {
	r = clamp(r, 0, 255);
	g = clamp(g, 0, 255);
	b = clamp(b, 0, 255);

	r = ((r.toString(16).length == 1) ? "0" + r.toString(16) : r.toString(16));
	g = ((g.toString(16).length == 1) ? "0" + g.toString(16) : g.toString(16));
	b = ((b.toString(16).length == 1) ? "0" + b.toString(16) : b.toString(16));

	return `#${r}${g}${b}`;
}

/** @see https://maketintsandshades.com/about */
export function shadeColor(hexColor, shade) {
	let r = parseInt(hexColor.substring(1, 3), 16);
	let g = parseInt(hexColor.substring(3, 5), 16);
	let b = parseInt(hexColor.substring(5, 7), 16);

	r = parseInt(r * (1 - shade));
	g = parseInt(g * (1 - shade));
	b = parseInt(b * (1 - shade));

    return rgbToHex(r, g, b);
}

/** @see https://maketintsandshades.com/about */
export function tintColor(hexColor, tint) {
	let r = parseInt(hexColor.substring(1, 3), 16);
	let g = parseInt(hexColor.substring(3, 5), 16);
	let b = parseInt(hexColor.substring(5, 7), 16);

	r = parseInt(r + (255 - r) * tint);
	g = parseInt(g + (255 - g) * tint);
	b = parseInt(b + (255 - b) * tint);

	return rgbToHex(r, g, b);
}

export const createColorPallet = (colorName, colorValue) => ({
    [`${colorName}-shade-1`]: shadeColor(colorValue, 0.4),
    [`${colorName}-shade-2`]: shadeColor(colorValue, 0.6),

    [`${colorName}-tint-1`]: tintColor(colorValue, 0.4),
    [`${colorName}-tint-2`]: tintColor(colorValue, 0.6),
})

const brightnessThreshold = 130

export const getTextColor = (hex) => {
	const color = hexToRgbObject(hex)
	if (!color) { throw new Error(`${hex} is not valid hex color`) }
	const brightness = (color.r * 299 + color.g * 587 + color.b * 114) / 1000;
    return brightness > brightnessThreshold ? '#000000' : '#ffffff';
}